import React from 'react'
import DailyTotalChart from './DailyTotalChart'

const MealsOverview = () => (
  <DailyTotalChart
    type="meal"
    title="Food Chart (portions)"
    link="meal"
    heatmapRanges={{
      low: 1,
      medium: 2,
      high: 3,
      veryHigh: 4,
    }}
  />
)

export default MealsOverview
